const state = {
  title: "",
  routeName: "",
  isBack: "",
  isHeaderShow: true,
  noFooter: false,
};

const mutations = {
  SET_TITLE: (state, title) => {
    state.title = title;
  },
  SET_ROUTE_NAME: (state, routeName) => {
    state.routeName = routeName;
  },
  SET_BACK: (state, isBack) => {
    state.isBack = isBack;
  },
  SET_HEADER_SHOW: (state, isHeaderShow) => {
    state.isHeaderShow = isHeaderShow;
  },
  SET_FOOTER_HIDE: (state, noFooter) => {
    state.noFooter = noFooter;
  },
};

const actions = {
  setTitle({ commit }, title) {
    commit("SET_TITLE", title);
  },
  setRouteName({ commit }, routeName) {
    commit("SET_ROUTE_NAME", routeName);
  },
  setBack({ commit }, isBack) {
    commit("SET_BACK", isBack);
  },
  setHeaderShow({ commit }, isHeaderShow) {
    commit("SET_HEADER_SHOW", isHeaderShow);
  },
  setNoFooter({ commit }, isHeaderShow) {
    commit("SET_FOOTER_HIDE", isHeaderShow);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
